import { env } from '@/config/env';

const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

/**
 * `POST /wholesalers/{id}/logo` stores a host-relative path (`/uploads/logos/…`) served by the
 * API origin, which resolves against the SPA's own origin and 404s if rendered verbatim.
 * Absolute and `data:` URLs pass through untouched.
 */
export const resolveApiAssetUrl = (path: string | null | undefined): string | null => {
  const trimmed = path?.trim() ?? '';

  if (trimmed === '') {
    return null;
  }
  if (ABSOLUTE_URL_PATTERN.test(trimmed)) {
    return trimmed;
  }

  // In dev VITE_API_BASE_URL is the bare `/api` prefix, so this yields an empty origin and the
  // path stays relative — vite.config.ts proxies `/uploads` to the same backend as `/api`.
  const apiOrigin = env.VITE_API_BASE_URL.replace(/\/api\/?$/, '').replace(/\/$/, '');
  const separator = trimmed.startsWith('/') ? '' : '/';

  return `${apiOrigin}${separator}${trimmed}`;
};
